import { render, staticRenderFns } from "./Lora.vue?vue&type=template&id=b653ee70&scoped=true&"
import script from "./Lora.vue?vue&type=script&lang=js&"
export * from "./Lora.vue?vue&type=script&lang=js&"
import style0 from "./Lora.vue?vue&type=style&index=0&id=b653ee70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b653ee70",
  null
  
)

export default component.exports